/* eslint-disable */
import 'instantsearch.css/themes/reset.css'
import React from 'react'
import axios from 'axios'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Card from 'components/Card/Card.jsx'
import Modal from 'components/Modal/Modal.jsx'
import Button from 'elements/CustomButton/CustomButton.jsx'
import '../../css/table.css'
import ReactTable from 'react-table'
import { orderBy, isEmpty, map, toArray } from 'lodash'
import { db, keygen } from '../../services/firebase'
import SweetAlert from 'react-bootstrap-sweetalert'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import StockProductForm from 'forms/StockProductForm.jsx'

export default class StockProducts extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alert: null,
            stock: [],
            products: [],
            loadingProducts: true,
            loadingStock: true,
            isModalVisible: false,
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchProducts()
        this._fetchStock()

    }

    render() {
        const { products, loadingProducts, alert, stock, loadingStock } = this.state
        return (
            <div className='main-content'>
                {alert}
                {this._formModal()}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='pull-right'
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                        this.props.resetForm('StockProductDiscount')
                                        this.setState({ isModalVisible: true })
                                    }}
                                >
                                    Adicionar Produto
                            </Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <ReactTable
                                    columns={[
                                        { Header: 'Modelo', accessor: 'model' },
                                        { Header: 'Item', accessor: 'item' },
                                        { Header: 'Quantidade', accessor: 'quantity' },
                                        { Header: 'Desconto (%)', accessor: 'discount' },
                                        { Header: 'Preço (Com desconto)', accessor: 'price' },
                                        {
                                            Header: 'Ações', accessor: '',
                                            Cell: ({ value }) => (this._renderTableActions(value))
                                        }
                                    ]}
                                    data={orderBy(this._prepareTableData(stock), ['model'], ['asc'])}
                                    onFetchData={this._fetchStock}
                                    loading={loadingStock}
                                    defaultPageSize={10}
                                    className='-striped -highlight'
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando'
                                    noDataText='Nenhum produto encontrado'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='Registros'
                                />
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    _prepareTableData = data => {
        const output = []

        map(data, d => {
            let item = { ...d }
            item.price = this._handleProductPrice(d.composition, d.discount)
            output.push(item)
        })

        return output
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`delete_${value.id}`}>Remover</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.removeStockAlert(value.id)}
                >
                    <FontAwesomeIcon className='text-dark' icon='trash' />
                </a>
            </OverlayTrigger>
        </div>
    )

    _handleProductPrice = (composition, discount) => {
        const multipleFabrics = this._checkComposition(composition)
        let decimalDiscount = Number(discount) / 100

        if (multipleFabrics) {
            let output = new Number(0)
            map(composition, c => {
                let percentagePrice = c.percentagePrice.split(' ')
                output += parseFloat(percentagePrice[1].replace(',', '.'))
            })

            let discountAmount = parseFloat(output) * decimalDiscount
            let price = output - discountAmount

            return `R$ ${parseFloat(price).toFixed(2).replace('.', ',')}`
        }

        if (!multipleFabrics) {
            let value = parseFloat(composition.value)
            let discountAmount = value * decimalDiscount
            let price = value - discountAmount

            return `R$ ${parseFloat(price).toFixed(2).replace('.', ',')}`
        }
    }

    _checkComposition = composition => {
        let validation = false

        map(Object.keys(composition), key => {
            typeof (composition[key]) === 'object' ? validation = true : validation = false
        })

        return validation
    }

    _fetchProducts = _ => {
        db.collection('products').get()
            .then(snapshot => {
                if (!snapshot.empty) {
                    const products = []
                    snapshot.forEach(product => products.push({ ...product.data(), id: product.id }))
                    this.setState({ products, loadingProducts: false })
                }

                if (snapshot.empty) {
                    this.props.notify('Nenhum produto encontrado.', 'warning')
                    this.setState({ loadingProducts: false })
                }

            })
            .catch(e => {
                this.props.notify('Erro ao buscar produtos.', 'error')
                this.setState({ loadingProducts: false })
            })
    }

    _fetchStock = () => {
        this.setState({ loadingStock: true })
        db.collection('stock').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passStockToState(snapshot)
                : this.setState({ loadingStock: false })
        )
    }

    _passStockToState = snapshot => {
        const stock = []
        snapshot.forEach(s => stock.push({ ...s.data(), id: s.id }))
        return this.setState({ loadingStock: false, stock })
    }

    _formModal = () => {
        const { isModalVisible, targetStock, products } = this.state
        return (
            <Modal
                size='modal__big'
                title='Adicionar Produto à Pronta Entrega'
                isOpen={isModalVisible}
                content={
                    <StockProductForm
                        products={products}
                        onSubmit={values => this._addProduct(values)}
                        handleCancel={() => this.setState({ isModalVisible: false })}
                    />
                }
            />
        )
    }

    _addProduct = product => {
        this.setState({ isModalVisible: false })
        this.waitAlert('Adicionando Produto', true)

        const id = keygen()
        const productToSave = {
            model: product.model.label,
            item: product.item.label,
            discount: product.discount,
            quantity: product.quantity,
            composition: { ...product.composition },
            coverImageURL: product.item.coverImageURL ? product.item.coverImageURL : null,
            productLine: product.item.productLine
        }

        db.collection('stock').doc(id).set({ ...productToSave })
            .then(() => {
                axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaStockAdd_HTTPS', {
                    id, data: productToSave
                })
                    .then(() => {
                        this.props.notify('Produto adicionado.', 'success')
                        this.hideAlert()
                    })
                    .catch(e => {
                        this.props.notify('Erro ao sincronizar dados.', 'error')
                        this.hideAlert()
                    })
            }).catch(e => {
                this.props.notify('Erro ao adicionar produto.', 'error')
                this.hideAlert()
                this.setState({ isModalVisible: true })
            })
    }

    _removeStock = id => {
        this.waitAlert('Removendo Produto', false)

        db.collection('stock').doc(id).delete()
            .then(() => {
                axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaStockDelete_HTTPS', { id })
                    .then(() => {
                        this.props.notify('Produto removido.', 'success')
                        this.props.notify('Caso ele não desapareça da lista, atualize a página.', 'info')
                        this.hideAlert()
                    })
                    .catch(e => {
                        this.props.notify('Erro ao sincronizar dados.', 'error')
                        this.hideAlert()
                    })
            })
            .catch(e => {
                this.props.notify('Erro ao remover produto.', 'error')
                this.hideAlert()
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeStockAlert = id => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeStock(id)
                    }
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Sim"
                    cancelBtnText="Não"
                    showCancel
                />
            )
        });
    }
}



// WEBPACK FOOTER //
// ./src/views/StockProducts/StockProducts.jsx